export const APP_CONFIG = {
  name: 'Archon',
  icon: '🏛️',
  description: 'Administrative Dashboard',
  version: '1.0.0',
} as const
